import * as React from "react";

const SvgBurger = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 4.00195H21V6.00195H3V4.00195ZM3 11.002H15V13.002H3V11.002ZM3 18.002H21V20.002H3V18.002Z" fill="#F8F8F8" /></svg>;

export default SvgBurger;